
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {authorizeCertApi, userApi} from "@/api/organization";
    import SetTableColumns from "@/components/SetTableColumns.vue";
    const {CodeToText} =require("@/js/region/region");
    @Component({
        name: "authorizeCompanyList",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        title = "所在单位管理";
        listData: any = [];
        // listParam: IPage = {
        //     size: 10,
        //     current: 1,
        // };
        propParams = {
            name: ''
        }
        mode = 0
        CodeToText = CodeToText
        // listTotal = 0;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        allSelected = [];
        load = false;
        tableKey = 0;
        created() {
            // const route = this.$route;
            // const q = JSON.parse(JSON.stringify(route.query));
            // if (q.size) {
            //     this.listParam.size = Number(q.size);
            //     this.listParam.current = Number(q.current);
            // }
            this.mode = Number(this.$route.params.mode);
            this.list();
        }
        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        // indexMethod(index: any) {
        //     return (this.listParam.current - 1) * this.listParam.size + index + 1;
        // }

        list() {
            Promise.all([userApi.getOrganizationInfo(),
                authorizeCertApi.getOrganizationCertCount()]).then((arr)=>{
                const res1 = arr[0];
                const res2 = arr[1];
                if(res1.data.result != 0){
                    this.$message.error(res1.data.message);
                    return;
                }
                if(res2.data.result != 0){
                    this.$message.error(res2.data.message);
                    return;
                }
                const data = res1.data.data;
                data.certCount = res2.data.data;
                this.listData = [data];
                this.load = true;
                this.$nextTick(()=>{
                    let $table = this.$refs.table as HTMLFormElement;
                    if($table){
                        $table.doLayout();
                    }
                })
            });
        }
        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        toAuthorizeCertList(ownerId: number){
            this.$router.push(`/authorizeCert/List/${ownerId}/0`);
        }
        refresh() {
            this.list();
        }
        // @Watch("$route.path")
        // get$routePath() {
        //     this.mode = Number(this.$route.params.mode);
        //     this.refresh();
        // }
    }
